import {mapStateToProps, mapDispatchToProps} from "../redux/redux";
import {connect} from "react-redux";
import React from 'react';
import {SettingsTabs, state} from "./tabs";
import {Progress, Label, Input, UncontrolledTooltip} from "reactstrap";
import GuideLabel from '../guide_labels/label';

class SettingsCon extends React.Component {

    constructor(props) {
        super(props);

    this.mainPage = this.mainPage.bind(this);
    this.tips = this.tips.bind(this);
    }
    mainPage() {
        this.props.updateState(state);
        if (this.props.state.custom) this.props.clearBars();

        document.querySelector(".main_page--hook_sett").style.pointerEvents = "none";

        setTimeout(() => {
           this.props.updateState(this.props.state.custom ? {settings: false, custom: false} : {settings: false});
           document.querySelector(".main_page").classList.remove("main_page--settAnim", "main_page--settAnim--back");
              }, 700);
              
              document.querySelector("nav").classList.remove("nav--out");
        
        document.querySelector(".main_page").classList.add("main_page--settAnim--back");
        setTimeout(() => {
            document.querySelector(".settings--hook").style.pointerEvents = "auto";
            if (this.props.state.custom) {
                console.log("gener")
                this.props.nextGen();
            } 
        }, 800);
    }

    tips() {
        this.props.updateState({tips: !this.props.state.tips})
    }

    componentDidMount() {
        document.querySelector(".settings_page").style.height = document.querySelector(".main_page").clientHeight + "px";

        document.querySelector("nav").classList.add("nav--out");

        let usedClass = document.querySelector(".main_page").classList;
        usedClass.remove("main_page--settAnim", "main_page--settAnim--back")
        usedClass.toggle("main_page--settAnim");
        setTimeout(() => document.querySelector(".main_page--hook_sett").style.pointerEvents = "auto", 700)
    }
    render() {
        return (
            <div>
                
                <div className="settings_page">
                    <h1 className="display-4">Settings (W.I.P.)</h1>
                    <GuideLabel text={"Main Page"} mainSet={true} left={true} class={"main_page--hook_sett"} onMouseFunc={this.mainPage}/>
                    <div className="settings--inside">
                        

                    <Label style={{marginLeft: "5em"}} id="tips">
                        <Input type="checkbox" onClick={this.tips} defaultChecked={this.props.state.tips}/>Tips
                    </Label>
                    <UncontrolledTooltip target="tips" placement="right">Tips on hover</UncontrolledTooltip>

                    <SettingsTabs nextGen={this.props.nextGen}/>
                        
                        {/* <Progress multi>
                            <Progress bar style={{backgroundColor: "red"}} value={15}>whole</Progress>
                            <Progress bar style={{backgroundColor: "green"}} value={45}>half</Progress>
                            <Progress bar style={{backgroundColor: "black"}} value={40}>quarter</Progress>
                        </Progress> */}
                        
                    </div>
                    
                </div>
            </div>
        )
    }
}
let Settings = connect(mapStateToProps, mapDispatchToProps)(SettingsCon);

export default Settings;